// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__12NiV","left":"InfoRow_left__3HNj_"};